import { render } from "./centerStatisticsComponent.vue?vue&type=template&id=9aa308d0&scoped=true"
import script from "./centerStatisticsComponent.vue?vue&type=script&lang=js"
export * from "./centerStatisticsComponent.vue?vue&type=script&lang=js"

import "./centerStatisticsComponent.vue?vue&type=style&index=0&id=9aa308d0&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa308d0"]])

export default __exports__